import richText from "utilities/richText"

export default function ThreeColumnList({ blok }) {
  return <div className="prose max-w-full gap-16 px-10 py-6 lg:columns-3">{richText(blok.content)}</div>
}
